<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM11.6992 14.4004L11.3994 17.4004H11.0996L10.7998 14.4004L9.59961 10.5H6.59961L9.89941 18H12L17.3994 6H14.3994L11.6992 14.4004Z"
      fill="currentColor"
    />
  </svg>
</template>
